<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("smstemplate") }}</div>
      <router-link
        v-if="$can('create', 'SMS Template')"
        class="btn-blue"
        to="add-sms-template"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px;">
              <span class="pr-3">{{ $tc("status", 1) }}</span>
            </th>
            <th>{{ $t("smstemplate") }} {{ $t("name") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="smstemplateList && smstemplateList.length > 0">
          <tr
            v-for="(smstemplate, smstemplateIndex) in smstemplateList"
            :key="smstemplateIndex"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    smstemplate.sms_is_active === 'Y'
                      ? 'active'
                      : smstemplate.sms_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'SMS Template')"
                    v-on:click="onSMSTemp('Edit', smstemplate)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>

                  <b-dropdown-item v-on:click="onSMSTemp('View', smstemplate)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    smstemplate.sms_is_active === 'Y'
                      ? 'active'
                      : smstemplate.sms_is_active === 'N' && 'inactive'
                  "
                />

                <i
                  v-if="$can('update', 'SMS Template')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  v-on:click="onSMSTemp('Edit', smstemplate)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>

                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  v-on:click="onSMSTemp('View', smstemplate)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ smstemplate.sms_temp_name }}</td>
            <td class="text-center">
              <b-button
                variant="default"
                class="btn-blue"
                @click.prevent.stop="OpenModal(smstemplate)"
                >Test</b-button
              >
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="3">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>

    <b-modal
      id="smstest"
      class="modal-content"
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="modal-header mb-3 pt-0 pl-0 pr-0">
        <label class="h4 text-center">Send SMS</label>
        <!-- <button type="button" class="btn-clearDate text-right close" v-on:click="hideModal('smstest')">×</button> -->
        <button type="button" class="close" v-on:click="hideModal('smstest')">
          ×
        </button>
        <!-- <button type="button" aria-label="Close" class="close">×</button> -->
      </div>
      <div class="modal-body">
        <div class="d-flex align-items-center">
          <b-dropdown
            :text="SelectedCountryCode"
            variant="dropdown-curve"
            class="w-50 text-center mr-3"
          >
            <div class="px-2 pb-2">
              <input
                required
                autofocus
                type="search"
                placeholder="Search Code"
                class="form-control form-control-sm"
                v-on:keyup="onSearchCode($event.target.value)"
                v-on:keydown="onSearchCode($event.target.value)"
                v-on:search="onSearchCode($event.target.value)"
                v-model="searchCode"
              />
            </div>
            <b-dropdown-item
              href="#"
              v-for="(countrycode, countryIndex) in Countries"
              :key="countryIndex"
              v-on:click="onSelectHandler('countrycode', countrycode)"
              v-if="countrycode.country_mob_code != null"
              >{{ countrycode.country_mob_code }}</b-dropdown-item
            >
          </b-dropdown>
          <div class="input-material w-100">
            <input
              v-model="tomobileno"
              type="text"
              id="sms_contact_no"
              name="sms_contact_no"
              v-validate="'required|numeric|max:16'"
              placeholder="."
            />
            <label for="cn">Contact No</label>
          </div>
        </div>
        <p
          v-if="
            submitted &&
            (SelectedCountryCode == 'Code' || SelectedCountryCode.length == 0)
          "
          class="error_message"
        >
          Please select country code.
        </p>
        <p
          v-else-if="submitted && errors.has('sms_contact_no')"
          class="error_message"
        >
          {{ errors.first(`sms_contact_no`) }}
        </p>

        <br />
        <div class="text-center">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="SendSMS()"
          >
            Send
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      btenable: false,
      submitted: false,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      smstemplateList: [],
      mobilecode: "",
      mobilecodeID: "",
      tomobileno: "",
      tempdetails: [],
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },
      countrydet: [],
      SelectedCountryCode: "Code",
      CodeListCopy: [],
      searchCode: "",
    };
  },
  beforeMount() {
    this.getSMSTemplateList();
    this.getCountriesList();
    this.getviewingnumber();
  },
  methods: {
    getCountriesList: function () {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onSearchCode: function () {
      if (this.searchCode && this.searchCode.length > 0) {
        this.Countries = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CodeListCopy;
      }
    },
    getviewingnumber: function () {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getSMSTemplateList();
      } else {
        this.currentPage = event;
        this.getSMSTemplateList();
      }
    },

    OpenModal: function (data) {
      this.tempdetails = data;
      this.$bvModal.show("smstest");
    },
    hideModal: function (modal) {
      if (modal == "smstest") {
        this.btenable = false;
        this.submitted = false;
        this.SelectedCountryCode = "Code";
        this.tomobileno = "";
        this.$bvModal.hide("smstest");
      }
    },

    onSelectHandler: function (type, value, index) {
      if (type == "countrycode") {
        this.countrydet = value;
        this.SelectedCountryCode = value.country_mob_code;
      }
    },

    SendSMS: function () {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (
          this.SelectedCountryCode == "Code" ||
          this.SelectedCountryCode.length == 0
        ) {
          return;
        }
        if (valid) {
          this.$bvModal.hide("smstest");
          this.btenable = true;

          let loader = this.$loading.show();
          let payload = {
            tosms: this.tomobileno,
            template_id: this.tempdetails.sms_id,
            country_code: this.SelectedCountryCode,
          };
          MasterService.Sendsms(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;

              if (data && data.status) {
                this.submitted = false;
                this.tomobileno = "";
                this.SelectedCountryCode = "Code";
                this.$toasted.show(data.message);
              } else {
                // this.$toasted.show(data.message);
                this.$toasted.show(
                  "Unable to Send SMS. Please configure a SMS Service Provider"
                );
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    },

    onSMSTemp: function (type, data) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-sms-template",
          query: { sms_id: data.sms_id },
        });
      } else {
        this.$router.push({
          path: "/master/view-sms-template",
          query: { sms_id: data.sms_id },
        });
      }
    },

    getSMSTemplateList: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
      };
      MasterService.GetSMSTemplate(body)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.smstemplateList = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SMSTemplateComponents/listsmstemplate.vue